<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>職業安全衛生</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <p>職業安全一直是我們高度重視的議題，和平電力致力關注員工健康、工作環境和工作安全，其中“安全”更是員工、承包商和管理層的共同責任，「零工傷」是我們的重要目標，和平電力已通過 ISO 45001 職業安全衛生管理系統認證。</p>
        <div class="gallery">
          <div class="item imgContainer1-1"></div>
          <div class="item imgContainer1-2"></div>
          <div class="item imgContainer1-3"></div>
        </div>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <center>
          <div class="sectTit">職工的安全健康</div>
        </center>
        <div class="employeeSafety">
          <!-- <div class="item">
            <img class="icon" src="@/assets/safetyHealth/icon2_01.png">
            <div class="announce">針對職工的安全<br>和平電廠設置安衛處<br>負責安全衛生相關事務</div>
          </div> -->
          <div class="item" v-for="(row, idx) in employeeSafety" :key="idx">
            <div class="thumbnail" :style="setThumbnail(row.thumbnail)">
              <div class="tit">{{row.tit}}</div>
            </div>
            <div class="desp">{{row.desp}}</div>
          </div>
        </div>
        <br>
        <center>
          <div class="sectTit">承攬商的安全衛生教育</div>
        </center>
        <div class="supplyierSafety">
          <div class="item" v-for="(row, idx) in supplyierSafety" :key="idx">
            <div class="tit">{{row.tit}}</div>
            <div class="desp">{{row.desp}}</div>
            <img class="pic" :src="setSupplyierPic(row.thumbnail)" />
          </div>
        </div>
        <br>
        <center>
          <div class="sectTit">多元健康促進</div>
        </center>
        <div class="multiHealth">
          <div class="item" v-for="(row, idx) in multiHealth" :key="idx">
            <div class="tit">{{row.tit}}</div>
            <div class="desp">{{row.desp}}</div>
            <!-- <img class="pic" :src="setSupplyierPic(row.thumbnail)" /> -->
          </div>
          <swiper
            :modules = "modules"
            :slides-per-view="1"
            :space-between="1"
            :autoplay="{delay:3000, disableOnInteraction:false}"
            :speed="1000"
            :loop="true"
            :pagination="{clickable:true}"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
            class="swiper"
          >
            <swiper-slide class="cover cover1"></swiper-slide>
            <swiper-slide class="cover cover2"></swiper-slide>
            <swiper-slide class="cover cover3"></swiper-slide>
            <swiper-slide class="cover cover4"></swiper-slide>
            <swiper-slide class="cover cover5"></swiper-slide>
            <swiper-slide class="cover cover6"></swiper-slide>
          </swiper>
        </div>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <div class="sectTit">特殊資格人員的精進訓練</div>
        <p>每年依照政府現行法規，辦理勞動、職安及災害預防訓練等相關課程，並依法安排同仁進行急救人員、缺氧作業、危險性設備、職業安全衛生業務主管等相關證照之新訓與回訓。另外，透過盤點工作環境中的潛在安全危害因子，進行安全宣導及消防演習，並參加政府舉辦之各類型災害防治觀摩及各類職安證照回訓課程。</p>
        <div class="gallery">
          <div class="left">
            <div class="imgContainer4-1"></div>
          </div>
          <div class="right">
            <div class="imgContainer4-2"></div>
            <div class="imgContainer4-3"></div>
            <div class="imgContainer4-4"></div>
          </div>
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default defineComponent({
  name: 'SafetyHealth',
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide
  },
  setup() {
    const onSwiper = (swiper: any) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      // console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay]
    };
  },
  data() {
    return {
      employeeSafety: [
        {
          tit: "工前會議",
          desp: "每日工作開始前，讓所有人員了解當天的工作內容、作業風險及安全注意事項，促進工作團隊溝通，避免因資訊落差或疏忽而發生意外。",
          thumbnail: "pic2_01.jpg"
        },
        {
          tit: "人臉辨識",
          desp: "以單一出入口形式，員工與承攬商採分流方式，各別設置人臉辨識系統，透過生物識別技術管制人員進出狀況並結合職安辦公室數位工程監視，強化承攬管理。",
          thumbnail: "pic2_02.jpg"
        },
        {
          tit: "管線辨識",
          desp: "廠區管線以色彩強化內容物辨識，確保人員操作安全。",
          thumbnail: "pic2_03.jpg"
        },
        {
          tit: "工安月刊",
          desp: "每月職安管理狀況採數位期刊方式並輔以社群推廣，向全體員工宣導，閱讀完後並回填職安知識問答，以增加安全新知及強化安全意識。",
          thumbnail: "pic2_04.jpg"
        },
        {
          tit: "安全巡檢",
          desp: "除了依據安全管理系統定期大規模內部稽核巡檢，以查找出可能造成工作安全上的隱患，並以獎勵及公開表揚的方式鼓勵員工及包商，發掘現場潛在危險及提出可以精進安全的改善意見。",
          thumbnail: "pic2_05.jpg"
        },
        {
          tit: "身心健檢",
          desp: "和平電力每二年安排所有員工身體檢查，依據檢查數值進行追蹤、轉介專科及衛教輔導，並辦理衛教及身心專業講座。",
          thumbnail: "pic2_06.jpg"
        }
      ],
      supplyierSafety: [
        {
          tit: "入廠人員安全衛生教育及考核",
          desp: "設有「和平電廠安衛資訊平台」加強對承攬商管制，並要求遵守職業安全衛生相關法規及入廠時辦理安全衛生教育訓練，所有的基礎教育訓練均以影片方式呈現，通過考核後才能獲得許可入廠。",
          thumbnail: "pic2_07.jpg"
        },
        {
          tit: "工作票制度",
          desp: "承攬商施工前，須由電廠監工人員向票房申請工作許可，票房人員確保該施工區域已經完成斷電、洩壓或其他需要隔離的危害因子後，核發施工許可，承攬商方可進行施工或拆卸，嚴禁擅自施工。施工完成後亦向票房回報，票房會依據其上、下游可能影響的其他施工區域，判斷是否恢復供電運轉或繼續保持隔離。",
          thumbnail: "pic2_08.jpg"
        }
      ],
      multiHealth: [
        {
          tit: "成立職場健康促進小組",
          desp: "由跨部門人員組成職場健康促進小組，協力規劃多元健康促進活動與友善職場措施，如辦理每周定期運動、身心靈健康系列講座、戒菸減重班、健康飲食手作等，鼓勵員工培養良好的運動與飲食習慣，提升自我健康管理意識，並獲衛福部國民健康署「健康職場促進自主評核認證」。",
          thumbnail: "pic2_07.jpg"
        },
        {
          tit: "友善職場營造",
          desp: "打造員工多元空間，設有醫護室、諮商室等、哺集乳室等隱私溝通空間，每月定期辦理健康訪視，另設有多項職場不法侵害申訴管道，包含 Line@ 線上申訴管道、員工意見箱等，並定期發送職場不法侵害調查問卷，以主動關懷同仁職場工作是否遭遇不當之對待。",
          thumbnail: "pic2_08.jpg"
        }
      ]
    }
  },
  methods:{
    setSupplyierPic: function(file: string) {
      return require(`@/assets/safetyHealth/${file}`);
    },
    setThumbnail: function(thumbnail: string) {
      return {
        background: `url(${require(`@/assets/safetyHealth/${thumbnail}`)})`,
        backgroundSize: "cover"
      }
    }
  },
  mounted() {
    // let swiperPageination = (document.querySelector(".swiper-pagination") as HTMLElement).cloneNode(true);
    // (document.querySelector(".swiper") as HTMLElement).after(swiperPageination);    

    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-1") as HTMLElement, 1.15);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-2") as HTMLElement, 1.15);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-3") as HTMLElement, 1.15);
    document.querySelectorAll(".employeeSafety .thumbnail").forEach( (elem) => {
      new ImgContainerAutoResize(elem as HTMLElement, 0.65);
    });
    new ImgContainerAutoResize(document.querySelector(".swiper .cover1") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover2") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover3") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover4") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover5") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover6") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".imgContainer4-1") as HTMLElement, 1.595);
    new ImgContainerAutoResize(document.querySelector(".imgContainer4-2") as HTMLElement, 0.8);
    new ImgContainerAutoResize(document.querySelector(".imgContainer4-3") as HTMLElement, 0.8);
    new ImgContainerAutoResize(document.querySelector(".imgContainer4-4") as HTMLElement, 0.4);    
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/safetyHealth/kv.webp");
  background-position: center 20%;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 p {
  line-height: 2em;
}

.sect1 .gallery {
  margin: 40px 0 5px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect1 .gallery .item {
  flex: 0 0 32%;
  border-radius: 30px;
}

.sect1 .gallery .item.imgContainer1-1 {
  background: url("@/assets/safetyHealth/pic1_01.jpg") center;
  background-size: cover;
}

.sect1 .gallery .item.imgContainer1-2 {
  background: url("@/assets/safetyHealth/pic1_02.jpg") center;
  background-size: cover;
}

.sect1 .gallery .item.imgContainer1-3 {
  background: url("@/assets/safetyHealth/pic1_03.jpg") center;
  background-size: cover;
}

.sect2 {
  background: url("@/assets/safetyHealth/sectBack2.jpg") center;
  background-size: cover;
}

.sect2 .sectTit {
  padding: 10px 40px;
  display: inline-block;
  border-radius: 100px;
  font-size: 40px;
  color: #fff;
  background: #63BFAA;
}

.sect2 .employeeSafety {
  margin: 40px 0 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect2 .employeeSafety .item {
  flex: 0 0 31%;
  margin: 0 0 40px;
  overflow: hidden;
}

.sect2 .employeeSafety .item:nth-child(1) {
  /* text-align: center; */
}

.sect2 .employeeSafety .item .icon {
  width: 40%;
  margin: auto;
  display: block;
}

.sect2 .employeeSafety .item .announce {
  display: inline-block;
  margin: 10px 0 0;
  padding: 10px 0 0;
  border-top: solid 1px #0c5f99;
  font-size: 24px;
  color: #0c5f99;
}

.sect2 .employeeSafety .item .thumbnail {
  position: relative;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.sect2 .employeeSafety .item .thumbnail .tit {
  width: 180px;
  margin: auto;
  padding: 0 20px 1px;
  box-sizing: border-box;
  display: inline-block;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  background: #e99776;
}

.sect2 .employeeSafety .item .desp {
  padding: 10px 0;
  line-height: 1.8em;
  font-size: 16px;
}

.sect2 .supplyierSafety {
  margin: 40px 0;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.sect2 .supplyierSafety .item {
  flex: 0 0 40%;
}

.sect2 .supplyierSafety .item .tit {
  font-size: 24px;
  color: #0c5f99;
}

.sect2 .supplyierSafety .item .desp {
  padding: 15px 0 30px;
  line-height: 1.8em;
  font-size: 16px;
}

.sect2 .supplyierSafety .item .pic {
  width: 100%;
}

.sect2 .multiHealth {
  margin: 40px 0 0;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.sect2 .multiHealth .item {
  flex: 0 0 40%;
}

.sect2 .multiHealth .item .tit {
  font-size: 24px;
  color: #0c5f99;
}

.sect2 .multiHealth .item .desp {
  padding: 15px 0 30px;
  line-height: 1.8em;
  font-size: 16px;
}

.sect2 .swiper {
  flex: 1 0 100%;
  border-radius: 20px;
}

.sect2 .swiper .swiper-wrapper {
  /* overflow: hidden; */
}

.sect2 .swiper .cover1 {
    background: url("@/assets/safetyHealth/pic3_01.webp") center;
    background-size: cover;
}

.sect2 .swiper .cover2 {
    background: url("@/assets/safetyHealth/pic3_02.webp") center;
    background-size: cover;
}

.sect2 .swiper .cover3 {
    background: url("@/assets/safetyHealth/pic3_03.webp") center 75%;
    background-size: cover;
}

.sect2 .swiper .cover4 {
    background: url("@/assets/safetyHealth/pic3_04.webp") center;
    background-size: cover;
}

.sect2 .swiper .cover5 {
    background: url("@/assets/safetyHealth/pic3_05.webp") center;
    background-size: cover;
}

.sect2 .swiper .cover6 {
    background: url("@/assets/safetyHealth/pic3_06.webp") center 70%;
    background-size: cover;
}

.sect2 .swiper .swiper-pagination {
  /* bottom: -40px !important; */
}

.sect2 .swiper .swiper-pagination .swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  border: solid 1px #fff;
  background: #404040;
  opacity: 0.8;
}

.sect2 .swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #fff;
}

.sect3 .ctx {
  padding: 60px 0;
}

.sect3 p {
  line-height: 2em;
}

.sect3 .sectTit {
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect3 .gallery {
  margin: 20px 0 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: 30px;  
}

.sect3 .gallery .left {
  flex: 0 0 33.3%;
}

.sect3 .gallery .left .imgContainer4-1 {
  background: url(../../assets/safetyHealth/pic4_01.jpg) center no-repeat;
  background-size: cover;
}

.sect3 .gallery .right {
  flex: 0 0 66%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect3 .gallery .right .imgContainer4-2 {
  width: 49.5%;
  margin: 0 0 1%;
  background: url(../../assets/safetyHealth/pic4_02.jpg) center no-repeat;
  background-size: cover;
}

.sect3 .gallery .right .imgContainer4-3 {
  width: 49.5%;
  margin: 0 0 1%;
  background: url(../../assets/safetyHealth/pic4_03.jpg) center no-repeat;
  background-size: cover;
}

.sect3 .gallery .right .imgContainer4-4 {
  width: 100%;
  height: 55%;
  background: url(../../assets/safetyHealth/pic4_04.jpg) center no-repeat;
  background-size: cover;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect2 .employeeSafety .item {  
    flex: 0 0 47%;
  }

  .sect2 .supplyierSafety {
    justify-content: space-between;
  }

  .sect2 .supplyierSafety .item {
    flex: 0 0 47%;
  }

  .sect2 .multiHealth {
    justify-content: space-between;
  }

  .sect2 .multiHealth .item {
    flex: 0 0 47%;
  }

  .sect3 .ctx {
    padding: 40px;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect1 .gallery .item {
    flex: 0 0 100%;
    margin: 0 0 10px;
  }

  .sect2 .sectTit {
    font-size: 24px;
  }

  .sect2 .employeeSafety .item {  
    flex: 0 0 100%;
  }

  .sect2 .supplyierSafety .item {
    flex: 0 0 100%;
    margin: 0 0 20px;
  }

  .sect2 .multiHealth .item {
    flex: 0 0 100%;
    margin: 0 0 20px;
  }

  .sect3 .ctx {
    padding: 40px 20px;
  }

  .sect3 .gallery .left {
    flex: 0 0 100%;
  }

  .sect3 .gallery .right {
    flex: 0 0 100%;
  }

  .sect3 .gallery .right .imgContainer4-2 {
    width: 100%;
    margin: 5px 0;
  }

  .sect3 .gallery .right .imgContainer4-3 {
    width: 100%;
    margin: 0 0 5px;
  }

  .sect3 .gallery .right .imgContainer4-4 {
    width: 100%;
    height: 55%;
  }
}
</style>
